import operations from '~/helpers/device-operations';
import { fwPrivate, relayConnected, type } from '~/helpers/fields-description';
import { rfStatus, udpIp, udpPusher } from '~/helpers/network-fields-description';
import { BehaviorKey } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';

export class NAPlug extends Gateway {
    subtype?: string;
    behaviorFields: BehaviorKey[] = [
        'relay_polarity_inverted',
        'rf_statistics_enabled',
    ];

    get deviceOperations() {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.dumpLogs({ callback: this.dumpLogs }),
            operations.logs({ callback: this.logs }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
            operations.deleteCache({ callback: this.deleteCache }),
        ]);
    }

    get typeToDisplay() {
        return this.subtype ? this.subtype : this.type;
    }

    loadData(data: any) {
        data.room_id = data.room_id || 'Not in a room';
        super.loadData(data);
        this.loadHeatingAlgo(data.heating_algo);
    }

    get fieldType() {
        return type(this.type, this.typeToDisplay);
    }
    get fieldFwPrivate(): FieldObject | undefined {
        return fwPrivate(this.firmware_private);
    }

    get fieldRelayConnected() {
        if (this.network) {
            return relayConnected(this.network?.plug_connected_boiler);
        }
    }

    getNetworkFields(): FieldObject[] {
        let fields: FieldObject[] = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat([
                rfStatus(this.getRfIcon(this.network.rf_amb_status), this.network.rf_amb_status),
            ]);
            // If server_node field is present, the thermostat has been migrated, we don't need udp info anymore
            if (this.network.server_node) {
                fields = fields.concat(getServerNodeFields(this.network.server_node));
            } else {
                fields = fields.concat([
                    udpIp(this.network.udp_ip + ':' + this.network.udp_port),
                    udpPusher(this.network.udp_pusher),
                ]);
            }
        }
        return fields;
    }

}
